import RequestHandler from "./RequestHandler";

function ModelParametersAPI() {
    const baseURL = "model-parameters";

    async function deployModel(body) {
        try {
            const result = await RequestHandler.put(`${baseURL}/deploy`, body);
            return result;
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    async function deleteModel(id) {
        try {
            const result = await RequestHandler.remove(`${baseURL}/${id}`);
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function uploadModel(body) {
        try {
            const result = await RequestHandler.post(
                `${baseURL}/publish`,
                body
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function updateParameterSettings(body) {
        try {
            const result = await RequestHandler.put(
                `${baseURL}/parameter-settings`,
                body
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function getModelParameterDetails(id) {
        try {
            const result = await RequestHandler.get(`${baseURL}/details/${id}`);

            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function addModelParamter(payload) {
        try {
            const result = await RequestHandler.post(`${baseURL}`, payload);

            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        deployModel,
        deleteModel,
        uploadModel,
        updateParameterSettings,
        getModelParameterDetails,
        addModelParamter,
    };
}

export default ModelParametersAPI();
